// Locked-in shadow recipes from main.css. The card shadow is the
// "paper-cutout lift" that gives feature cards their physical-sheet
// presence; do not deviate without design sign-off.

export const shadows = {
  /** Multi-layer paper-cutout shadow for feature cards. */
  card: [
    '0 110px 180px -30px rgba(8, 18, 12, 0.58)',
    '0 60px 100px -16px rgba(8, 18, 12, 0.45)',
    '0 28px 48px -6px rgba(8, 18, 12, 0.36)',
    '0 10px 20px rgba(8, 18, 12, 0.26)',
    '0 2px 4px rgba(8, 18, 12, 0.22)',
    'inset 0 2px 0 rgba(255, 255, 255, 0.95)',
    'inset 0 -2px 0 rgba(8, 18, 12, 0.08)',
  ].join(', '),
  /** Soft drop for liquid-glass elements (menu box, sub-nav, glass wrappers). */
  glass: '0 6px 24px rgba(0, 0, 0, 0.18)',
  /** Subtle lift for drawing-pad canvases. */
  drawingPad: '0 2px 6px rgba(8, 18, 12, 0.08)',
} as const;

export type ShadowToken = keyof typeof shadows;
